import {PageStylesEnum} from "@shared/services/router/page-styles.enum";
import {Routes} from '@angular/router';
import {SigninComponent} from '@shared/pages/auth/signin/signin.component';
import {VerifyEmailComponent} from '@shared/pages/auth/verify-email/verify-email.component';

import {ForgotPasswordComponent} from '@shared/pages/auth/forgot-password/forgot-password.component';
import {ResetPasswordComponent} from '@shared/pages/auth/reset-password/reset-password.component';
import {PageNotFoundComponent} from '@shared/pages/page-not-found/page-not-found.component';
import {ProfileComponent} from "@ctms/profile/profile.component";
import {IcfAnonymousComponent} from "@ctms/participants/icf-anonymous/icf-anonymous.component";
import {HomeComponent} from "@shared/pages/home/home.component";
import {ctmsRoutes} from "@shared/services/router/ctms.routes";
import {cdssRoutes} from "@shared/services/router/cdss.routes";
import {SelectTypeComponent} from "@shared/pages/auth/select-type/select-type.component";
import {demoRoutes} from "@shared/services/router/demo.routes";
import {StepTwoComponent} from "@shared/pages/auth/signin/step-two.component";

export const routes: Routes = [
    {path: '', component: HomeComponent, pathMatch: 'full'},

    {path: 'signin', component: SigninComponent},
    {path: 'step-two', component: StepTwoComponent},
    {path: 'forgot-password', component: ForgotPasswordComponent},
    {path: 'reset-password/:token', component: ResetPasswordComponent},
    {path: 'signin-verify', component: VerifyEmailComponent},
    {path: 'profile', component: ProfileComponent, data: {style: PageStylesEnum.CREAM}},
    {path: 'sign-remote-icf', component: IcfAnonymousComponent},
    {path: 'select-type', component: SelectTypeComponent},

    ...ctmsRoutes,
    ...cdssRoutes,
    ...demoRoutes,

    {path: 'not-found', component: PageNotFoundComponent},
    {
        path: '**', redirectTo: '/not-found',
    },
];
